import { Component, OnInit } from '@angular/core';
import { ITestimony } from '../shared/models/testimony';
import { TestimonyService } from './testimony.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-testimony',
  templateUrl: './testimony.component.html',
  styleUrls: ['./testimony.component.css']
})
export class TestimonyComponent implements OnInit {
  selectedStar = 5;
  testimonyForm:FormGroup = new FormGroup({})
  testimonies: any[] = [];

   loading = false;
   submitted = false;
   message = '';
   
     successMessage = '';
     errorMessage = '';
 // snackbar: any;
  //router: any;
    constructor(private fb:FormBuilder, private testimonyService: TestimonyService) {

    this.testimonyForm = this.fb.group({
      fullName:['', [Validators.required]],
      comment:['', [Validators.required]],
      star:[5, [Validators.required]]
    })
   
    }
     ngOnInit(): void {
           this.getTestimonies();
         }
    getTestimonies(): void {
    this.testimonyService.getTestimonies().subscribe({
      next: (data) => {
       
        this.testimonies = data;
          console.log( this.testimonies);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
 
    submitTestimony() {
      
      console.log(this.testimonyForm.value)
       debugger;
        this.testimonyService.addproduct(this.testimonyForm.value).subscribe({
         next: (response) => {
         
          this.successMessage = 'Your testimony has been submitted successfully.';
          this.testimonyForm.reset();

        },
         error: (err) => {
           this.successMessage = '';
           this.errorMessage = 'Failed to submit your testimony.';
        }
      });
     }

  setRating(star: number): void {
   this.selectedStar = star;
  // If using a reactive form
    this.testimonyForm.patchValue({
     star: star
  });
}
     
}
